import axios from "../../components/shared/axios"
import { actions } from "../pages"

const savePage = async (state, action, dispatch) => {
  const params = new FormData(state.formRef)

  const response = await axios.put(state.saveUrl, params)

  if (response.data.redirect_now) {
    window.location = response.data.redirect_now
  } else {
    dispatch({ type: actions.SET_SAVING, payload: false })
  }
}

export { savePage }
